import $ from 'jquery'

export function initialise() {
  const $toggle = $('[data-toggle]')
  const $targets = $('[data-toggle-target]')

  $toggle.on('click', function (event) {
    const $this = $(this)
    const id = $this.data('toggle')
    const $target = $(`[data-toggle-target="${id}"]`)

    event.preventDefault()

    $this.toggleClass('open')
    $target.toggleClass('open')
  })
}
